<app-checkbox
	[value]="data.value"
	[enabled]="data.enabled"
	[tooltip]="data.tooltip"
	[label]="'&nbsp;'"
	(valueChange)="data.callback()"
></app-checkbox>
